// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__biqhi","box":"WorkspacesBox_box__3Zsrq","node":"WorkspacesBox_node__2d0Gq"};